<template>
  <div id="registration">
    <v-card>
      <h2>{{ $t("forgot_password") }}</h2>
      <v-form ref="form" v-model="isFormValid" @submit.prevent="onSubmit">
        <p>
          {{ $t("forgot_passwod_text") }}
        </p>
        <v-text-field
          v-model="email"
          :rules="[rules.required, rules.email]"
          class="my-1"
          outlined
          dense
          :label="$t('enter_email')"
        />
        <v-btn class="registration-btn" type="submit">{{ $t("send") }}</v-btn>
      </v-form>
      <div class="login-link">
        <router-link to="prihlaseni">{{ $t("back_to_login") }}</router-link>
      </div>
    </v-card>

    <v-dialog v-model="showDialog" max-width="500">
      <v-card>
        <h2>{{ $t("password_recovery_title") }}</h2>
        <p>
          {{ $t("password_recovery_text") }}
        </p>
        <div class="text-center">
          <v-btn @click="showDialog = false">{{
            $t("passord_recovery_button")
          }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      isFormValid: true,
      showDialog: false,
      rules: {
        required: value => !!value || this.$t("validate_required"),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("validate_email");
        }
      }
    };
  },
  methods: {
    async sendEmail() {
      try {
        await this.$http.post("doctors/forgotten-password", {
          email: this.email
        });
        this.showDialog = true;
      } catch {
        // eslint-disable-next-line no-console
        console.error("Connection error");
      }
    },
    onSubmit() {
      this.$refs.form.validate();
      if (this.isFormValid) {
        this.sendEmail();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#registration {
  .login-link {
    max-width: 25rem;
    margin: 2rem auto 0 auto;
    text-align: center;
  }

  #login-message {
    padding: 1rem;
    font-size: 0.9rem;
    margin-bottom: 1rem;
    background: rgb(253, 192, 192);
  }

  .v-card {
    padding: 2rem;
    max-width: 25rem;
    margin: auto;
    box-shadow: 0px 0px 18px 0px #d1d1d1;
  }

  .registration-btn {
    width: 100%;
    background: #324c8d;
    color: white;
  }

  h2 {
    padding-bottom: 2rem;
  }

  @media only screen and (max-width: 500px) {
    h2 {
      padding-bottom: 0;
    }
    padding: 16px 5px;
  }
}

.v-dialog {
  h2 {
    margin-bottom: 1rem;
  }

  .v-card {
    padding: 2rem;
  }

  .v-btn {
    margin-top: 1rem;
    background-color: #324c8d !important;
    color: white;
  }
}
</style>
